import React, { useState, useEffect } from "react";
import { FaPhoneAlt, FaWhatsapp, FaArrowUp } from "react-icons/fa";

const FloatingButtons = () => {
  const [isVisible, setIsVisible] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 200) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <div className="fixed bottom-6 right-6 flex flex-col items-center gap-4 z-50">
      {/* Call Button */}
      <a
        href="tel:+919777797668"
        className="flex items-center justify-center w-14 h-14 rounded-full bg-blue-600 text-white shadow-lg hover:scale-110 transition"
      >
        <FaPhoneAlt size={20} />
      </a>

      {/* WhatsApp Button */}
      <a
        href="https://wa.me/919777797668"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center w-14 h-14 rounded-full bg-green-500 text-white shadow-lg hover:scale-110 transition"
      >
        <FaWhatsapp size={22} />
      </a>

      {/* Scroll To Top Button */}
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="flex items-center justify-center w-14 h-14 rounded-full bg-orange-500 text-white shadow-md hover:scale-110 transition"
        >
          <FaArrowUp size={16} />
        </button>
      )}
    </div>
  );
};

export default FloatingButtons;